<!-- 产业服务--农机租赁-->
<template>
<div class="site-content">
  <div class="site-content-page">
    <div class="content-row">
      <div class="content-col col-per-70">
        <infoPageList-04 title="农机租赁" label="INFORMARION" :showTitle="true" :showMore="false" :showOrder="false" :showTagSearch="true"  :infoBlock="infoBlock" :infoPage="infoPage"  :tabList="tabList" :filterList="filterList" tabDefaultType="1" tabClass="list-tab-ul-1" count="10" v-on:queryPage="njzl_Req"/>
      </div>
      <div class="content-col col-per-30">
        <infoList title="推荐农机" label="INFORMARION" :showTitle="true" :showMore="false" :infoBlock="infoBlock" :infoPage="infoPage1" v-on:queryPage="tjnz_Req" titleLength="20" count="4"/>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import InfoPageList04 from '../block/InfoPageList04'
import InfoBlock18 from '../block/InfoBlock18'
import InfoList from '../block/InfoList'

export default {
  name: 'Cyfw05',
  components: {
    'infoPageList-04': InfoPageList04,
    'InfoList': InfoList,
  },
  data() {
    return {
      msg: '',
      tabList:[],
      infoBlock:InfoBlock18,
      infoPage:{page:{},list:[]},
      infoType:'means',
      filterList:[],
      infoPage1:{page:{},list:[]},
    }
  },
  methods:{
    //农机分类
    njfl_Req(){
      let that=this;
      let params={};
      params.type='machinery';
      that.$dataApi.meansFilterList(params).then(res =>{
        console.log('请求Vue-axios结果：'+JSON.stringify(res))
        that.msg=res.msg;
        that.filterList=res.data.filter_list;
        //console.log('结束请求Vue-axios：'+JSON.stringify(result))
      });
    },
    //农资销售
    njzl_Req(params){
          let that=this;
          params.type='machinery';
          let result={page:params};
          that.$dataApi.meansLists(params).then(res =>{
            //console.log('请求Vue-axios结果：'+JSON.stringify(res))
            that.msg=res.msg;
            result.list= res.data.list;
            result.page.total=res.data.total;
            that.infoPage=result;
            //console.log('结束请求Vue-axios：'+JSON.stringify(result))
          });
     },
     //推荐农资
     tjnz_Req(params){
           var date = new Date();
           let that=this;
           if(this.Global.siteTabId>0){params.tag_id=this.Global.siteTabId;}
           let result={page:params};
           console.log(params.title+'开始请求Vue-axios,参数：'+JSON.stringify(params));
           that.$dataApi.meansRecommendList(params).then(res =>{
           //console.log('请求Vue-axios结果：'+JSON.stringify(res))
           that.msg=res.msg;
           result.list= res.data.list;
           result.page.total=res.data.total;
           that.infoPage1=result;
           //console.log('结束请求Vue-axios：'+JSON.stringify(result))
           });
     },
  },
  created:function(){
    this.njfl_Req();
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.col-per-70 {
  flex-grow:4;
}

.col-per-30 {
  flex-grow:1;
}
</style>



// WEBPACK FOOTER //
// src/components/page/Cyfw05.vue